import { useState, useCallback, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Header from "@/pages/home/components/Header";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";

interface NewsLink {
  label: string;
  url: string;
}

interface NewsItem {
  id: string;
  date: string;
  title: string;
  body: string;
  linkUrl?: string;
  linkLabel?: string;
  links?: NewsLink[];
  expandableSections?: { title: string; content: string }[];
}

const newsData: NewsItem[] = [
  {
    id: "changes-to-the-board",
    date: "NOV 2025",
    title: "Changes to the Board of Trustees",
    body: "The Musicians\u2019 Pension Fund of Canada would like to formally announce the retirement of Employer Trustee and Vice-Chair, Eddy Bayens, from the Board of Trustees. Mr. Bayens has served the members of the Fund dutifully for over 20 years. In that time, he has helped guide the Fund through multiple economic crises while contributing to the strengthening of the financial health of the Plan. His leadership, collaborative spirit and wisdom will be greatly missed. The Musicians\u2019 Pension Fund of Canada, and its members, thank Mr. Bayens for his decades of faithful service.\n\nMr. Bayens will be succeeded as Vice-Chair by Bernard LeBlanc. Mr. LeBlanc has served on the MPF Canada Board of Trustees for 10 years. He has completed all appropriate IFEBP training and that knowledge, combined with his years of experience, made him the right candidate for the position. He was unanimously appointed as Vice-Chair by the remaining Trustees.\n\nThe Musicians\u2019 Pension Fund of Canada also welcomes David Owen to the Board of Trustees. The Trustees appointed Mr. Owen to the Employee Trustee position vacated by Mr. Bayens. Mr. Owen plays the Oboe, as well as the English Horn. He has been a member of the Vancouver Opera Orchestra, Turning Point Ensemble and Canadian Chamber Orchestra. He is also a fully trained lawyer who practiced law while continuing his performing career. He was appointed secretary of the Vancouver Musicians Association in 2011. He moved to Halifax in 2021, where he was appointed President of the Atlantic Federation of Musicians Local 571. Mr. Owen has pledged to uphold the mission of the Fund, which is to administer the Plan in a prudent manner to ensure its long term viability in order to provide the best possible retirement benefits to the Fund\u2019s members and beneficiaries.",
  },
  {
    id: "passing-of-jill-giustino",
    date: "JAN 2025",
    title: "Announcement of the Passing of Jill Giustino, Executive Director",
    body: "Read the official announcement from the Musicians\u2019 Pension Fund of Canada.",
    linkUrl: "/wp-content/uploads/nl-202501/English.html",
    linkLabel: "Read Announcement",
  },
  {
    id: "extension-to-recent-plan-amendment",
    date: "JAN 2021",
    title: "Extension to Recent Plan Amendment",
    body: "Read the official notice regarding the extension to the recent Plan amendment.",
    linkUrl: "/wp-content/uploads/nl-202101/English.html",
    linkLabel: "Read Notice",
  },
  {
    id: "covid-19-pandemic",
    date: "APR 2020",
    title: "COVID-19 Pandemic and Financial Market Volatility",
    body: "Read the Fund\u2019s official COVID-19 update and related questions and answers.",
    links: [
      { label: "Read Update", url: "/wp-content/uploads/nl-202004-Covid/2020-04-CovidFin-web/english.html" },
      { label: "Read Q&As", url: "/wp-content/uploads/nl-202004-Covid/2020-04-Covid19QA-web/english.html" },
    ],
  },
  {
    id: "feb-2019-announcement",
    date: "FEB 2019",
    title: "Announcement",
    body: "Read the official 2019 announcement from the Musicians\u2019 Pension Fund of Canada.",
    linkUrl: "/wp-content/uploads/2019/02/Announcement-2019.pdf",
    linkLabel: "Read Announcement",
  },
  {
    id: "may-2017-intl-musicians-article",
    date: "MAY 2017",
    title: "Important Notice regarding the May 2017 International Musician\u2019s Article",
    body: "Read the important notice regarding the May 2017 International Musician\u2019s Article.",
    linkUrl: "/wp-content/uploads/2017/05/FR-Important-Notice-re-Article-by-Ray-Hair-2017.pdf",
    linkLabel: "Read Notice",
  },
  {
    id: "jun-2016-announcement",
    date: "JUN 2016",
    title: "Announcement",
    body: "Read the official June 2016 announcement from the Musicians\u2019 Pension Fund of Canada.",
    linkUrl: "/wp-content/uploads/2016/06/Announce20160627en.pdf",
    linkLabel: "Read Announcement",
  },
  {
    id: "feb-2016-quebec-bill-34",
    date: "FEB 2016",
    title: "Quebec Bill 34 Update",
    body: "Read the February 2016 update regarding Quebec Bill 34.",
    linkUrl: "/wp-content/uploads/2016/03/Flyer20160306_en.pdf",
    linkLabel: "Read Update",
  },
  {
    id: "nov-2015-quebec-bill-34",
    date: "NOV 2015",
    title: "Quebec Bill 34 Update",
    body: "Read the November 2015 update regarding Quebec Bill 34.",
    linkUrl: "/wp-content/uploads/2016/03/Bill_34_English",
    linkLabel: "Read Update",
  },
  {
    id: "may-2014-gmmq-referendum",
    date: "MAY 2014",
    title: "GMMQ / Local 406 CFM/AFM Referendum Vote on Disaffiliation",
    body: "The Trustees of the Musicians\u2019 Pension Fund of Canada were informed that the Guilde des Musiciens et Musiciennes du Qu\u00e9bec (GMMQ) was holding a referendum from June 2\u20138, 2014 on its disaffiliation from the AFM.\n\nThe Trustees were asked whether GMMQ members would be able to continue their participation in the Pension Plan, and whether Quebec members\u2019 accrued benefits and pensions would be safe should the vote lead to disaffiliation. A series of Trustee meetings was held during which these questions were fully considered.",
    linkUrl: "/wp-content/uploads/2016/03/Trustee-Letter-GMMQ-Referendum-English.pdf",
    linkLabel: "Read Response",
  },
  {
    id: "jan-2014-2013-results-strong",
    date: "JAN 2014",
    title: "2013 Results Strong; Fund Challenges Continue",
    body: "The New Year has seen many calls and e-mails to the Fund Office from members keen to know if 2013 was a good year for the plan. Rather than answer each call individually, we decided it would be better to issue an all-member communication so everyone has exactly the same information.\n\n2013 was a good year for the Plan\u2019s investments. We achieved a return of 18% over the year and our asset value at December 31 grew to $675M.",
    linkUrl: "/wp-content/uploads/2016/03/January-2014-English.pdf",
    linkLabel: "Read More",
  },
  {
    id: "jan-2013-faq-benefit-changes",
    date: "JAN 2013",
    title: "FAQ Questions Benefit Changes 2013",
    body: "1. Why were we given such short notice about these Plan changes?\n\nThis was certainly not the Fund\u2019s choice. We could not make any announcement until the Financial Services Commission of Ontario (FSCO, the regulator) approved both the change and our communications material.",
    linkUrl: "/wp-content/uploads/2016/03/FAQ-Questions-Benefit-Changes-2013.pdf",
    linkLabel: "Read More",
  },
  {
    id: "dec-2012-notice-of-plan-changes",
    date: "DEC 2012",
    title: "MPF Canada Notice of Plan Changes",
    body: "We wish to inform you of some changes to the Plan that will come into effect on January 1, 2013 in order to comply with recent changes in provincial funding requirements.\n\nHow will these changes affect me?\n\nThese changes only affect contributions on a go-forward basis.",
    links: [
      { label: "Read Notice", url: "/wp-content/uploads/2016/03/Notice-of-Plan-Changes-December-2012.pdf" },
      { label: "Read Background Information", url: "/wp-content/uploads/2016/03/Background-Information-December-2012.pdf" },
    ],
  },
  {
    id: "dec-2012-notice-to-pensioners",
    date: "DEC 2012",
    title: "Notice to Pensioners",
    body: "Dear Pensioners and Beneficiaries:\n\nWe wish to inform you that some changes to the Plan will come into effect on January 1, 2013.",
    linkUrl: "/wp-content/uploads/2016/03/Notice-to-Pensioners-December-2012.pdf",
    linkLabel: "Read More",
  },
  {
    id: "mar-2012-kinross-class-action",
    date: "MAR 2012",
    title: "Kinross Class Action \u2013 Summary of the Action",
    body: "The Trustees of the Musicians\u2019 Pension Fund of Canada are the plaintiffs in a shareholder class action commenced on March 12, 2012 in the Ontario Superior Court of Justice against Kinross Gold Corporation and several members of its senior management.",
    linkUrl: "/wp-content/uploads/2012/03/Summary-of-Kinross-Class-Action-March-15-2012.pdf",
    linkLabel: "Read More",
  },
  {
    id: "oct-2010-plan-changes",
    date: "OCT 2010",
    title: "Plan Changes",
    body: "Plan changes are being made effective January 1, 2011. Please refer to the Fall 2010 Newsletter for changes.",
    linkUrl: "/wp-content/uploads/2015/15/InConcert-Fall-2010.pdf",
    linkLabel: "View Newsletter",
  },
  {
    id: "jan-2009-somepp-election-notice",
    date: "JAN 2009",
    title: "SOMEPP Election Notice",
    body: "We wish to inform you that the Trustees have filed an election with the Superintendent of the Financial Services Commission of Ontario (FSCO) to have the American Federation of Musicians\u2019 and Employers\u2019 Pension Welfare Fund (Canada) designated as a Specified Ontario Multi-Employer Pension Plan (SOMEPP).",
    expandableSections: [
      {
        title: "Read full SOMEPP Election Notice",
        content: "What is a SOMEPP?\n\nOur Plan is already recognized as a Multi-Employer Pension Plan (MEPP) under the Pension Benefits Act of Ontario. The SOMEPP designation is a new category of MEPP designed to provide temporary relief from the current solvency funding requirements while the Province develops a more permanent solution for solvency funding.\n\nJanuary 1, 2008 actuarial valuation\n\nAn Actuarial Valuation of the Plan was performed as of January 1, 2008. It showed the Plan is more than fully funded on a \u201cgoing-concern\u201d basis. This means that as of January 1, 2008, the Plan\u2019s assets more than cover the costs of accrued benefits, based on the assumption that the Plan will keep operating indefinitely.\n\nUnder pension law, the Actuary must also do a solvency valuation on a \u201cwind-up\u201d basis as of January 1, 2008. This valuation assumes the Plan ceases to operate, liquidates all its investments and pays out all benefits as of the valuation date. Measured this way, the Plan\u2019s assets would cover 92% of the benefit costs. Please note that this situation is purely hypothetical \u2014 in actual fact, the Plan was not wound up. Rather, we expect it to keep operating for many years in the future as it has done for over 40 years.\n\nTemporary relief from solvency funding\n\nNormally, the Province would require some action to address the solvency shortfall, and for a MEPP like ours this might entail benefit reductions. However, with the SOMEPP designation, the Plan will not need to address the solvency shortfall for three years (2008\u20132010). This three-year exemption will have no impact on your pension benefit except in the very unlikely event that the Plan terminates and the assets are not sufficient to fund all accrued benefits at that time. In that very unlikely event, benefits would have to be reduced.",
      },
      {
        title: "Read background information",
        content: "What\u2019s a valuation?\n\nIt\u2019s a financial check-up of the pension plan. As a registered pension plan providing defined benefits, our Plan must file a valuation with the Ontario pension authority at least every three years. Valuations are done by actuaries, independent professionals with special expertise in this area.\u00a0They use commonly accepted methods and assumptions to assess whether the plan\u2019s assets are sufficient to meet its obligations to pay benefits, both now and in the future. They consider information already known for certain (e.g., members\u2019 ages and accrued benefits, the plan\u2019s benefit formula, the fund\u2019s assets, and employers\u2019 current contribution rates). They also make very long-term, conservative assumptions about what will happen in the future (e.g., at what age will members retire? how long will they live after they retire? how much investment income will the fund earn, on average, while members are building up and eventually receiving their benefits?)\n\nWhat\u2019s a going-concern valuation?\n\nThis kind of valuation assumes the pension plan will keep operating indefinitely. It takes a long-term view, recognizing that pension benefits are typically earned, funded and paid out over many years. For example, a member may earn benefits over 30-40 years and receive a pension for another 25+ years. Similarly, the plan’s assets are expected to have many years in which to accumulate and earn investment income. On this basis, short-term fluctuations in investment results are not very important – it’s the overall long-term rate of return that matters.\n\nWhat\u2019s a wind-up/solvency valuation?\n\nA solvency valuation looks at what would happen if the plan were wound up immediately. It takes a short-term approach and measures the level of benefit security if a plan is suddenly terminated (e.g., if the employer cancels the plan or goes out of business). This could be a real concern with a single-employer plan, but is less likely in a multi-employer pension plan like ours where many employers are involved and contribution rates are set out in negotiated agreements.\n\nShould we be concerned about the shortfall?\n\nIt\u2019s not unusual for pension plans to have a solvency shortfall. In fact, over 3 out of 4 pension plans that filed valuations in Ontario from July 2004 to June 2007 reported ratios below 1.00, and about half were below 0.90. With a solvency ratio of 0.92 at 1/1/08, our Plan is actually healthier than many others. (The valuation dates in this comparison are not the same \u2013 if all plans were valued when ours was, they would likely have lower ratios and bigger shortfalls.)\u00a0The solvency valuation is just one measure of a pension plan\u2019s financial health, and does not actually fit the situation of a multi-employer pension plan. The reality is, our Plan did not terminate on January 1, 2008. Rather, it is expected to continue to operate for many more years.\n\nHow healthy is our Plan?\n\nBased on the going-concern valuation, our Plan is fully funded as of 1/1/08 and actually has some excess assets. Of course, these results do not reflect the market declines of the last few months. Still, the excess assets provide a cushion that helps soften the impact of recent declines. Our Pension Fund is invested for the long term, so time is on our side. It is diversified among various asset classes and designed to withstand short-term market fluctuation. Over the last 40 years, the Fund has come through many cycles of market volatility.\n\nWhat happens after three years?\n\nOntario has introduced the SOMEPP designation on a temporary basis while it continues to examine the funding issues. This happened after many MEPP trustees and their advisors, faced with growing concerns about solvency funding, called for the Province to review the rules. They pointed out that the regular standards didn\u2019t fit the multi-employer plan situation \u2013 particularly since MEPPs are less likely to be terminated suddenly.\u00a0Hopefully, the Province will introduce permanent changes in funding requirements in the near future that are more suitable for plans like ours. As we move forward, the Trustees will continue to closely monitor the Plan\u2019s financial health with a view to protecting the health and security of the Pension Fund for many years to come.",
      },
    ],
  },
  {
    id: "oct-2008-volatility-in-stock-markets",
    date: "OCT 2008",
    title: "Volatility in the Stock Markets",
    body: "Our fund, along with many pension funds, has seen many \u201cups and downs\u201d in the markets since inception. Right now, the markets seem particularly volatile, but history tells us that this type of volatility does not last forever. Please know that we are monitoring the situation closely. And remember that we\u2019re \u201cin for the long term\u201d.\n\nWhenever we consider making any changes, we do so with a view to the long-term health and security of the fund\u2019s pension promise. We\u2019ll continue to watch as local and global events unfold, and consult with our advisors as necessary. We will keep you posted in the event there is any significant long-term impact on the fund.\n\nPlease keep in mind the Fund is a Defined Benefit Fund- this is explained in our FAQ section (#s 1 and 7).",
  },
  {
    id: "dec-2007-disability-pension-notice",
    date: "DEC 2007",
    title: "Disability Pension Notice",
    body: "Plan members who apply for a disability pension on and after January 1, 2008 will be ineligible to receive a disability pension if they are eligible to receive disability benefits from their employer or under an insurance program provided by their employer. Pensioners who are in receipt of a disability pension on December 31, 2007 are not affected by this rule. Please contact the Fund office if further information is required.",
  },
  {
    id: "aug-2007-trustee-update",
    date: "AUG 2007",
    title: "Trustee Update",
    body: "Employee Trustee Bobby Herriot, after many years of dedicated service to the Federation (including his tenure as a Trustee of the Fund) announced his retirement effective July 31, 2007. We thank Bobby for his service to the Fund and extend best wishes to both Bobby and Etta for a long, happy and healthy retirement. We welcome Bill Skolnik, newly elected Vice President from Canada, AFM, to the position of Employee Trustee.",
  },
  {
    id: "feb-2007-notice-to-pensioners",
    date: "FEB 2007",
    title: "Notice to Pensioners",
    body: "In answer to enquiries about an increase for 2007 we advise that there are no changes to pensions in pay at this time. Although the Trustees have on many occasions in the past provided ad hoc increases to pensions in pay, the Plan rules do not provide for any automatic increases (i.e. cost of living increases). The Fund continues to be financially sound and the Trustees will again in the future consider further ad hoc increases.",
  },
  {
    id: "dec-2006-new-employee-trustee",
    date: "DEC 2006",
    title: "New Employee Trustee",
    body: "The AFM-EPW Fund (Canada) is pleased to welcome our new Employee Trustee, Charles Barbeau. Mr. Barbeau is the Vice President of the Quebec Musicians\u2019 Guild.",
  },
];

export default function News() {
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultId = "changes-to-the-board";

  const getInitialId = (): string => {
    const article = searchParams.get("article");
    if (article && newsData.some((n) => n.id === article)) return article;
    return defaultId;
  };

  const [selectedId, setSelectedId] = useState(getInitialId);
  const [expandedSections, setExpandedSections] = useState<Record<string, boolean>>({});
  const selectedItem = newsData.find((n) => n.id === selectedId) ?? newsData[0];

  const handleSelect = useCallback((id: string) => {
    setSelectedId(id);
    setSearchParams({ article: id }, { replace: true });
  }, [setSearchParams]);

  const toggleSection = useCallback((sectionKey: string) => {
    setExpandedSections((prev) => ({ ...prev, [sectionKey]: !prev[sectionKey] }));
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <Navbar />

      <main className="flex-1">
        {/* Page header */}
        <section className="w-full bg-[#0d1f4c] py-10">
          <div className="max-w-[1200px] mx-auto px-6">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-6 h-0.5 bg-[#1a8fc1]"></div>
              <span className="text-[#7ec8e3] text-xs font-semibold tracking-widest uppercase">
                Fund Updates
              </span>
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-3">
              News &amp; Updates
            </h1>
            <p className="text-base text-white/70 max-w-[560px]">
              Read the latest announcements, notices, and updates from the Musicians&rsquo; Pension Fund of Canada.
            </p>
          </div>
        </section>

        {/* Mobile dropdown */}
        <div className="lg:hidden w-full bg-[#f4f8fc] border-b border-gray-100 py-4">
          <div className="max-w-[1200px] mx-auto px-6">
            <label htmlFor="news-select" className="sr-only">Select News Item</label>
            <select
              id="news-select"
              value={selectedId}
              onChange={(e) => handleSelect(e.target.value)}
              className="w-full text-sm font-medium text-[#0d1f4c] bg-white border border-gray-200 rounded-lg px-4 py-3 appearance-none cursor-pointer focus:outline-none focus:border-[#1a8fc1] focus:ring-2 focus:ring-[#1a8fc1]/20"
              style={{
                backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%230d1f4c' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\")",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 12px center",
                paddingRight: "40px",
              }}
            >
              {newsData.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.date} — {item.title}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Two-column body — self-contained module */}
        <div className="w-full bg-white">
          <div className="max-w-[1200px] mx-auto px-6 py-8">
            <div className="flex flex-col lg:flex-row border border-gray-100 rounded-lg overflow-hidden bg-white">
              {/* Left sidebar — desktop */}
              <aside className="hidden lg:flex flex-col w-[320px] flex-shrink-0 border-r border-gray-100 bg-[#fafcfe] lg:h-[620px]">
                <div className="px-6 py-4 border-b border-gray-100">
                  <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-widest">
                    Archive
                  </h3>
                </div>
                <nav className="flex-1 overflow-y-auto py-1 [&::-webkit-scrollbar]:w-1 [&::-webkit-scrollbar-thumb]:bg-gray-200/80 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-transparent">
                  {newsData.map((item) => {
                    const isActive = item.id === selectedId;
                    return (
                      <button
                        key={item.id}
                        onClick={() => handleSelect(item.id)}
                        className={`w-full flex items-start gap-3 px-6 py-2.5 text-left transition-all duration-200 cursor-pointer ${
                          isActive
                            ? "bg-[#e8f2f9] border-l-2 border-[#1a8fc1]"
                            : "border-l-2 border-transparent hover:bg-[#f4f8fb]"
                        }`}
                      >
                        <div className="flex-1 min-w-0">
                          <span className={`block text-[10px] font-semibold tracking-wide uppercase mb-0.5 ${
                            isActive ? "text-[#1a8fc1]" : "text-gray-400"
                          }`}>
                            {item.date}
                          </span>
                          <span className={`block text-[13px] leading-snug ${
                            isActive ? "text-[#0d1f4c] font-semibold" : "text-gray-600 font-normal"
                          }`}>
                            {item.title}
                          </span>
                        </div>
                        {isActive && (
                          <span className="mt-1.5 w-1.5 h-4 rounded-full bg-[#1a8fc1] flex-shrink-0"></span>
                        )}
                      </button>
                    );
                  })}
                </nav>
              </aside>

              {/* Right detail panel */}
              <div className="flex-1 min-w-0 bg-[#fafbfd]">
                <div className="p-6 lg:p-8">
                  {/* Mobile title — shown only on mobile */}
                  <div className="lg:hidden mb-4">
                    <span className="inline-block text-xs font-semibold text-[#1a8fc1] tracking-widest uppercase bg-[#f4f8fc] px-3 py-1 rounded-full mb-3">
                      {selectedItem.date}
                    </span>
                  </div>

                  {/* Date badge — desktop */}
                  <span className="hidden lg:inline-block text-xs font-semibold text-[#1a8fc1] tracking-widest uppercase bg-[#f4f8fc] px-3 py-1 rounded-full mb-4">
                    {selectedItem.date}
                  </span>

                  <h2 className="text-xl md:text-2xl font-bold text-[#0d1f4c] mb-4 leading-tight">
                    {selectedItem.title}
                  </h2>

                  <div className="w-10 h-0.5 bg-[#1a8fc1] mb-5"></div>

                  <div className="text-sm text-gray-500 leading-relaxed max-w-[740px]">
                    {selectedItem.body.split("\n\n").map((para, i) => (
                      <p key={i} className={i > 0 ? "mt-3" : ""}>{para}</p>
                    ))}
                  </div>

                  {selectedItem.expandableSections && selectedItem.expandableSections.length > 0 && (
                    <div className="flex flex-col gap-2 mt-5">
                      {selectedItem.expandableSections.map((section, i) => {
                        const sectionKey = `${selectedItem.id}-section-${i}`;
                        const isExpanded = expandedSections[sectionKey] === true;
                        return (
                          <div key={sectionKey}>
                            <button
                              onClick={() => toggleSection(sectionKey)}
                              className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#1a8fc1] border border-[#1a8fc1]/40 rounded-lg px-4 py-2.5 hover:bg-[#f4f8fc] hover:border-[#1a8fc1] transition-colors cursor-pointer whitespace-nowrap"
                            >
                              {section.title}
                              <i className={`${isExpanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-sm transition-transform`}></i>
                            </button>
                            {isExpanded && (
                              <div className="mt-3 ml-1 pl-4 border-l-2 border-[#1a8fc1]/30 text-sm text-gray-500 leading-relaxed max-w-[740px]">
                                {section.content.split("\n\n").map((para, j) => (
                                  <p key={j} className={j > 0 ? "mt-3" : ""}>{para}</p>
                                ))}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {selectedItem.links && selectedItem.links.length > 0 ? (
                    <div className="flex flex-wrap gap-3 mt-5">
                      {selectedItem.links.map((link, i) => (
                        <a
                          key={i}
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#1a8fc1] border border-[#1a8fc1]/40 rounded-lg px-4 py-2.5 hover:bg-[#f4f8fc] hover:border-[#1a8fc1] transition-colors cursor-pointer whitespace-nowrap"
                        >
                          {link.label}
                          <i className="ri-arrow-right-up-line text-sm"></i>
                        </a>
                      ))}
                    </div>
                  ) : selectedItem.linkUrl && (
                    <a
                      href={selectedItem.linkUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={
                        selectedItem.id === "passing-of-jill-giustino" || selectedItem.id === "extension-to-recent-plan-amendment" || selectedItem.id === "feb-2019-announcement" || selectedItem.id === "may-2017-intl-musicians-article" || selectedItem.id === "jun-2016-announcement" || selectedItem.id === "feb-2016-quebec-bill-34" || selectedItem.id === "nov-2015-quebec-bill-34" || selectedItem.id === "may-2014-gmmq-referendum" || selectedItem.id === "jan-2014-2013-results-strong" || selectedItem.id === "jan-2013-faq-benefit-changes" || selectedItem.id === "dec-2012-notice-to-pensioners" || selectedItem.id === "mar-2012-kinross-class-action" || selectedItem.id === "oct-2010-plan-changes"
                          ? "inline-flex items-center gap-1.5 mt-5 text-sm font-semibold text-[#1a8fc1] border border-[#1a8fc1]/40 rounded-lg px-4 py-2.5 hover:bg-[#f4f8fc] hover:border-[#1a8fc1] transition-colors cursor-pointer whitespace-nowrap"
                          : "inline-flex items-center gap-1.5 mt-5 text-sm font-medium text-[#1a8fc1] hover:text-[#1780a8] transition-colors cursor-pointer whitespace-nowrap"
                      }
                    >
                      {selectedItem.linkLabel || "Read"}
                      <i className="ri-arrow-right-up-line text-sm"></i>
                    </a>
                  )}


                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}